import {updateAutoAdd, list} from "@/services/api/app/seat-management/backupsettings";
import {getEnableSpecialFolders} from "@/services/api/app/common/enableBackup";

const defaultState = () => ({
  loaded: false,
  autoAdd: {
    users: true,
    sites: true,
    teams: true,
    mailboxes: true,
    areEwsSpecialFoldersEnabled: true,
  },
  isEnableGroups: null,
  includeUnlicensed: {
    users: true,
    mailboxes: true,
  },
  isEntraEnabled: false,
  isUserChatEnabled: true,
});

export default {
  namespaced: true,

  actions: {
    list({commit}) {
      commit('setLoaded', false);
      return list()
        .then((data) => {
          if (data?.autoAdd) {
            commit('setAutoAdd', {
              ...data,
              ...data.autoAdd,
            })
          }
          if (data?.includeUnlicensed) {
            commit("setIncludeUnlicensed", {
              ...data,
              ...data.includeUnlicensed
            });
          }
          if (data?.isEntraEnabled) {
            commit('setIsEntraEnabled', !!data.isEntraEnabled);
          }
          if (data.isUserChatEnabled != null) {
            commit("setIsUserChatEnabled", data.isUserChatEnabled);
          }
          if (typeof data.isEnableGroups !== "undefined") {
            commit("setIsEnableGroups", data.isEnableGroups);
          }
          if (typeof data.areEwsSpecialFoldersEnabled !== "undefined") {
            commit("setAutoAdd", {
              ...data.autoAdd,
              areEwsSpecialFoldersEnabled: data.areEwsSpecialFoldersEnabled
            });
          }
          commit('setLoaded', true);
      });
    },
    updateAutoAdd({commit}, data) {
      return updateAutoAdd(data)
        .then(({autoAdd, ...data}) => {
          commit('setAutoAdd', {...autoAdd, ...data})
        })
    },
    updateIncludeUnlicensed({commit}, data) {
      return updateAutoAdd(data)
        .then(({includeUnlicensed, ...data}) => {
          commit('setIncludeUnlicensed', {...includeUnlicensed, ...data})
        })
    },
    getEnableSpecialFolders({commit, dispatch, state}) {
      return getEnableSpecialFolders()
        .then((data) => {
          state.autoAdd = data
        })
    },

  },

  mutations: {
    setAutoAdd(state, autoAdd) {
      state.autoAdd = autoAdd
    },
    setIncludeUnlicensed(state, includeUnlicensed) {
      state.includeUnlicensed = includeUnlicensed;
    },
    setIsEntraEnabled(state, val) {
      state.isEntraEnabled = !!val;
    },
    setIsUserChatEnabled(state, isUserChatEnabled) {
      state.isUserChatEnabled = isUserChatEnabled;
    },
    setIsEnableGroups(state, isEnableGroups) {
      state.isEnableGroups = isEnableGroups;
    },
    setLoaded(state, value) {
      state.loaded = value;
    }
  },

  getters: {
    //seatType: usersSeat, sitesSeat, teamsSeat, mailboxSeat
    getAutoAddSettingByType: (state) => (seatType) => {
      return state.autoAdd && state.autoAdd[seatType];
    },
    getIsUserChatEnabled: (state) => {
      return state.isUserChatEnabled
    },
    getIncludeUnlicensed: (state) => (seatType) => {
      return state.includeUnlicensed && state.includeUnlicensed[seatType];
    },
    isEntraEnabled: (state) => state.isEntraEnabled,
  },

  state: defaultState
}
